function addValueRecursive (key, value, fromIndex, param, object)
{
    let index = key.indexOf('[', fromIndex)
    if (index >= 0) {
        fromIndex =  index + 1

        let endIndex = key.indexOf(']', fromIndex)

        let keyItem = key.slice(fromIndex, endIndex)

        if (keyItem) {
            if(Array.isArray(object)) {
                object.push({[keyItem]: null})
                addValueRecursive(key, value, fromIndex, keyItem, object[object.length - 1])
            } else {
                object[param] = object[param] || {[keyItem]: null}
                addValueRecursive(key, value, fromIndex, keyItem, object[param])
            }
        } else {
            if(Array.isArray(object)) {
                object.push([])
                addValueRecursive(key, value, endIndex + 1, null, object[object.length - 1],)
            } else {
                object[param] = object[param] || []
                addValueRecursive(key, value, endIndex + 1, null, object[param],)
            }
        }

        return
    }

    if(Array.isArray(object)) {
        object.push(value)
        return
    }

    object[param] = value
}

function deleteEmptyField(data) {
    if (typeof data !== 'object') {
        return data
    }

    let isArray = Array.isArray(data)

    let keys = isArray ? data : Object.keys(data)

    for (let key of keys) {
        if (typeof data[key] === 'object') {
            data[key] = deleteEmptyField(data[key])
        }

        if (data[key] === null || data[key] === undefined || data[key] === '') {
            if (isArray) {
                data.splice(key, 1);
            } else {
                delete data[key]
            }
        }
    }

    if (isArray) {
        return data.length > 0 ? data : undefined
    } else {
        return Object.keys(data).length > 0 ? data : undefined
    }
}

function convertFormDataToObject(formData, includeEmptyField = true) {
    let object = {}

    formData.forEach((value, key) => {
        let index = key.indexOf('[')
        if (index > 0) {
            addValueRecursive(key, value, 0, key.slice(0, index), object)
        } else {
            object[key] = value
        }
    });

    if (! includeEmptyField) {
        deleteEmptyField(object)
    }

    return object
}

/**
 * @param  {URL} url
 * @param  {Object|null} object
 * @param  {string|undefined} parent
 */
function convertFormDataToUrl(url, object, parent = undefined) {
    if (!object) {
        return
    }

    Object.keys(object).forEach(key => {
        let param = key

        if (typeof key === 'string' && key.slice(-2) === '[]') {
            param = key.slice(key.length - 2)
        }

        if (parent) {
            param = parent + '[' + key + ']'
        }

        if (typeof object[key] === 'object') {
            convertFormDataToUrl(url, object[key], param)
        } else {
            url.searchParams.append(param, object[key])
        }
    })
}

export { convertFormDataToUrl, convertFormDataToObject }
